import { Box } from '@mui/material';
import TableCard from 'lib/designSystem/Card/TableCard';
import { formatDate } from 'lib/functions/utils';
import { SummaryRow } from 'pages/Finance/Components/Financing/common/Summary';
import React from 'react';

interface ConfirmingPayment {
  amount: number;
  businessDestinationIdentifier?: string;
  businessDestinationName?: string;
  executedAt?: Date | string;
}

interface ConfirmingRequest {
  payments?: ConfirmingPayment[];
  stakeholderName?: string;
  stakeholderIdentifier?: string;
  createdAt?: Date | string;
}

interface DetailsSummaryProps {
  request: ConfirmingRequest;
}

const DetailsSummary: React.FC<DetailsSummaryProps> = ({ request }) => {
  return (
    <TableCard
      size="medium"
      enabledEffects={false}
      sx={{ boxShadow: 'none', border: 'none', background: 'transparent' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <SummaryRow
          label="Cliente confirming"
          value={request.stakeholderName || ''}
          valueMaxLength={40}
        />
        <SummaryRow
          label="Rut cliente confirming"
          value={request.stakeholderIdentifier || ''}
        />
        <SummaryRow
          label="Fecha de solicitud"
          value={
            request.createdAt
              ? formatDate(request.createdAt as Date, 'dd-mm-yyyy')
              : ''
          }
        />
      </Box>
    </TableCard>
  );
};

export default DetailsSummary;
